import { computed, Injectable } from '@angular/core';
import { selectCurrentServiceId, selectFolder } from '../../../../store/person/person.selectors';
import {
    ComponentStoreV2Factory,
} from 'packages/client/src/app/modules/shared/store/common/component-store-v2.factory';
import { globalStore } from '../../../../../shared/shared.global-service';

@Injectable()
export class SelectWorkplaceDialogStore extends ComponentStoreV2Factory {

    public serviceId = globalStore!.selectSignal(selectCurrentServiceId);
    public folder = globalStore!.selectSignal(selectFolder);
    public service = computed(() => this.globalGlobalStore.organizationStore.getServiceBySignalId(this.serviceId)());
}
